import $ from 'jquery'
import 'slick-carousel'

$('.hero-slides').each(function (el) {
  $(this).slick({
    dots: true,
    arrows: false,
    fade: true,
    cssEase: 'linear',
    autoplay: true,
  })
})
